module.exports = __webpack_public_path__ + "media/images/design/images/btn_event-d43179c83373aaa3b0e261d65c88eb51.png";